const QuoteFormWrapper = ({ children }) => {
  return (
    <div className="step-enter">
      <div className="CustomizeQuoteDiv">
        <div className="form">
          <div className="border">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default QuoteFormWrapper;
